import Vue from 'vue'
import numeral from 'numeral'

Vue.filter('numeral', (value, format = '0,0.[00]') => numeral(value).format(format))
